import React from 'react'
import LineChartLayout from '../../layouts/LineChartLayout'
import PieChartLayout from '../../layouts/PieChartLayout'
import NumberHorizontalLayout from '../../layouts/NumberHorizontalLayout'
import classnames from 'classnames'

let data = [
  {
    title: 'Number of Discharges',
    description: 'Number of discharges within the filter range.',
    format: 'number_horizontal',
    endpoint: 'number_of_discharges'
  },
  {
    title: 'Number of Alumni Contacted',
    description: 'Number of Alumni that were followed up with.',
    format: 'number_horizontal',
    endpoint: 'number_of_kept_up_with_alumni'
  },
  { // !THIS DATA IS FAKE AND ONLY FOR MARIAH TO PITCH TO ORGS
    title: 'Number of Relapses',
    description: 'Number of relapses that occur after the discharge date.',
    format: 'number_horizontal',
    endpoint: 'alumni_number_of_relapses',
    visible: true,
    is_fake: true
  },
  { // !THIS DATA IS FAKE AND ONLY FOR MARIAH TO PITCH TO ORGS
    title: 'Number of Successes',
    description: 'Number of discharged clients that did not relapse post discharge.',
    format: 'number_horizontal',
    endpoint: 'alumni_number_of_successes',
    visible: true,
    is_fake: true
  },
  { // !THIS DATA IS FAKE AND ONLY FOR MARIAH TO PITCH TO ORGS
    title: 'Average Number of Days Sober Post Discharge',
    description: 'Average number of days a client is sober post discharge until (if any) relapse date.',
    format: 'number_horizontal',
    endpoint: 'average_number_of_days_sober_post_discharge',
    visible: true,
    is_fake: true
  },
  { // !THIS DATA IS FAKE AND ONLY FOR MARIAH TO PITCH TO ORGS
    title: 'Average Number of Meeting Attended by Alumni per Week',
    description: 'Average number of meetings attended by alumni that are attending meetings post discharge.',
    format: 'number_horizontal',
    endpoint: 'average_number_of_meetings_attended_by_alumni_per_week',
    visible: true,
    is_fake: true
  },
  { // !THIS DATA IS FAKE AND ONLY FOR MARIAH TO PITCH TO ORGS
    title: 'Percent Employed Post Discharge',
    description: 'Number of clients employed post discharge of total that have moved out.',
    format: 'pie_chart',
    endpoint: 'percent_employed_post_discharge',
    visible: true,
    is_fake: true
  },
]

export default function GeneralOutcomesData(props){
  const { organization_name } = props

  function selectFormat(metric, index){
    let hasLeftMargin = index % 2 != 0
    switch(metric.format){
      case "line_graph":
        return ( 
          <div className={classnames("pt-3 mt-5", "col-12", "pl-0", { "pl-lg-3": true })} key={index}>
            <div className='bg-reg shadow'>
              <LineChartLayout {...props} metric={metric} dataKey={metric.dataKey} index={index} hasLeftMargin={hasLeftMargin}/> 
            </div>
          </div>
        )
        break
      case "pie_chart":
        return ( 
          <div className={classnames("pt-3 mt-5", "col-12", "col-lg-6", "pl-0", { "pl-lg-3": true })} key={index}>
            <div className='bg-reg'>
              <PieChartLayout {...props} metric={metric} index={index} hasLeftMargin={hasLeftMargin}/> 
            </div>
          </div>
        )
        break
      case "number_horizontal":
        return ( 
          <div className={classnames("pt-3 mt-5", "col-12", "col-lg-6", "pl-0", { "pl-lg-3": true })} key={index}>
            <div className='bg-reg shadow mt-2'>
              <NumberHorizontalLayout {...props} metric={metric} index={index} hasLeftMargin={hasLeftMargin}/> 
            </div>
          </div>
        )
        break
    }
  }
  return(
    <div className="col-12 d-flex flex-wrap">
      {
        data.map((metric, index)=>{
          if (metric.is_fake) {
            if (organization_name == 'sober-homes' || organization_name == 'treatment-center') {
              return selectFormat(metric, index)
            }
          } else {
            return selectFormat(metric, index)
          }
        })
      }
      <div className="py-3" />
    </div>
  )
}